import { getLocales, Locale } from 'react-native-localize';
import build from '../config/build';

const defaultLocale = 'en-AU';

const getLocaleToUse = () => {
  if (build.variant.isElite) {
    // elite is (for now at least) always en-AU
    //  this can later change to persist the value, and read it here
    return defaultLocale;
  }

  const locales: Locale[] = [];
  locales.push.apply(locales, getLocales());
  return locales[0].languageTag || defaultLocale;
};

export default getLocaleToUse;
